/**
 * App hook
 */
import { Vue } from '+/deps/env'
import hook from '+/deps/hook'
import utils from './util'
import template from './template.html'
import ElementUI from 'element-ui'
import mavonEditor from 'mavon-editor'
import components from '@/modules'
import i18n from '@/widgets/i18n'
import { setAppData } from '@/deps/utils'
import { get } from 'lodash'
import './element-variables.scss'
import './style.styl'
import '../deps/directive'
import 'mavon-editor/dist/css/index.css'
import VueTinymce from '@packy-tang/vue-tinymce'

// 安装组件
Vue.use(VueTinymce)
Vue.use(ElementUI)
Vue.use(mavonEditor)
Object.keys(components).forEach(k => Vue.component(k, components[k]))
Object.keys(utils).forEach(k => {
  Vue.prototype[`$${k}`] = utils[k]
})
hook('switch@route', function(options) {
  let userData = JSON.parse(sessionStorage.getItem('userData'))
  let token = get(userData, 'token', '')
  if (token) {
    setAppData('$defaultRequestHeader', { Authentication: token })
  }
})
// 数据挂钩
hook('prepare@app', function() {
  return {
    appData: null,
    routerOptions: {}
  }
})
// App component挂钩，将component configs传递给resolve完成初始化
hook('create@app', function(options) {
  // Set default request params
  return {
    i18n,
    template,
    computed: {
      isCollapse() {
        return this.$store.state.isCollapse
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/app/index.js